import React from 'react';
import KoobInputText from './KoobInputText';

type KoobSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
} & Omit<
  React.ComponentProps<typeof KoobInputText>,
  'value' | 'onChange' | 'iconLeft' | 'placeholder'
>;

// KoobInputText with a search icon and a string onChange — one height (md),
// so it always lines up with the other fields in a filter row. Remaining
// props (disabled, onFocus, iconRight, data-testid, ...) pass through.
export default function KoobSearchBar({
  value,
  onChange,
  placeholder,
  ...props
}: KoobSearchBarProps) {
  return (
    <KoobInputText
      iconLeft={<i className="fa-regular fa-magnifying-glass" />}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    />
  );
}
